var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33334 10.833C8.69121 11.3114 9.1478 11.7073 9.67213 11.9938C10.1965 12.2802 10.7763 12.4506 11.3722 12.4933C11.9682 12.5359 12.5663 12.45 13.1261 12.2411C13.6859 12.0323 14.1943 11.7055 14.6167 11.283L17.1167 8.78298C17.8757 7.99714 18.2956 6.94463 18.2861 5.85214C18.2767 4.75965 17.8384 3.7146 17.0659 2.94207C16.2934 2.16953 15.2483 1.73133 14.1558 1.72184C13.0634 1.71234 12.0108 2.13232 11.225 2.89131L9.79167 4.31631M11.6667 9.16631C11.3088 8.68787 10.8522 8.29199 10.3279 8.00553C9.80355 7.71906 9.22375 7.54871 8.62779 7.50603C8.03184 7.46335 7.43368 7.54934 6.87388 7.75816C6.31408 7.96698 5.80574 8.29375 5.38334 8.71631L2.88334 11.2163C2.12434 12.0022 1.70437 13.0547 1.71386 14.1472C1.72335 15.2396 2.16156 16.2847 2.93409 17.0572C3.70663 17.8298 4.75168 18.268 5.84416 18.2775C6.93665 18.2869 7.98916 17.867 8.775 17.108L10.2 15.683",
    stroke: "#187DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/referral.621d52557c17c3b673c37505cff91766.svg";
export { ForwardRef as ReactComponent };